import type { User } from '../domain/user'
import type { IUserRepository } from '../domain/IUserRepository'

export class CreateUserUseCase {
    constructor(private repository: IUserRepository) {}

    async execute(data: Omit<User, 'id'>): Promise<User> {
        if (!data.name || data.name.trim().length === 0) {
            throw new Error('El nombre es requerido')
        }

        if (!data.email || !this.isValidEmail(data.email)) {
            throw new Error('El email es inválido')
        }

        if (!data.roleId || data.roleId === 0) {
            throw new Error('El rol es requerido')
        }

        // Si viene warehouseId debe ser un número positivo válido.
        // Si no viene (rol administrador), se omite sin error.
        if (data.warehouseId !== undefined && data.warehouseId !== null) {
            if (!Number.isInteger(data.warehouseId) || data.warehouseId <= 0) {
                throw new Error('El warehouse seleccionado no es válido')
            }
        }

        return await this.repository.create(data)
    }

    private isValidEmail(email: string): boolean {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return emailRegex.test(email)
    }
}
